// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumLock-cls1_f5D","cls2":"PremiumLock-cls2__5B PremiumLock-cls1_f5D"};